import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ios-install',
  templateUrl: './ios-install.component.html',
  styleUrls: ['./ios-install.component.scss'],
})
export class IosInstallComponent implements OnInit {

  constructor(private modalc:ModalController, private translate:TranslateService) { }
  public language:string=null;
  ngOnInit() {
    this.language=this.translate.getBrowserLang();
  }

  close(){
    this.modalc.dismiss();
  }

}
